import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

/**
 * A switch in the app's own light blue.
 *
 * `color="secondary"` paints it #28419d — a navy that reads as an alert beside the quiet blues
 * everything else on these pages carries, so the control drew the eye before the content did.
 * `primaryColor[300]` is the same light blue as the cards and the type pills, and it is `primary.light`
 * rather than a shade picked by eye; the `color` prop cannot reach it, which is why this is an `sx`.
 */
export const softSwitchSx: SxProps<Theme> = {
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: theme.palette.primaryColor[300],
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: theme.palette.primaryColor[300],
    },
};
